import { render, staticRenderFns } from "./studentNewFile.vue?vue&type=template&id=93d0650a"
import script from "./studentNewFile.vue?vue&type=script&lang=js"
export * from "./studentNewFile.vue?vue&type=script&lang=js"
import style0 from "./studentNewFile.vue?vue&type=style&index=0&id=93d0650a&prod&lang=less&scope=true"
import style1 from "./studentNewFile.vue?vue&type=style&index=1&id=93d0650a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports